import { ConfirmCompareProductsSchema } from "@redotech/redo-agents-cards/support-agents/confirm-compare-products";
import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { literal } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";

export const ProductComparisonMessageSchema =
  BaseActionableComponentMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_COMPARISON),
    structuredContent: ConfirmCompareProductsSchema,
  });

export const ProductComparisonMessageDbParser =
  ProductComparisonMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductComparisonMessage = z.infer<
  typeof ProductComparisonMessageDbParser
>;
